
import IndexInterno from "./_Index.vue"
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
const authStore = namespace('auth');
import { Prop } from 'vue-property-decorator';

@Options({
    name: "DisciplinaSegundaChamada",
    components: { IndexInterno },
})
export default class DisciplinaSegundaChamada extends Vue {
    @authStore.Getter
    public perfis!: any

    @Prop() readonly disciplina!: any

    public modal_cadastro;

    created() {
        this.modal_cadastro = 'kt_cadastrar_disciplina_segunda_chamada';
    }
}
